module.exports = __webpack_public_path__ + "img/homeIncome4.0eeb3303.png";